<!-- fieldsetLinksRapidosEQuestaoFavoritaContraido -->
<!-- [style]="{'padding': '0px 0px', 'margin': '0px 0px 0px 0px'}" -->
<p-fieldset
  class="fieldset-link-rapido"
  [toggleable]="true"
  [collapsed]="true">

  <p-header>
    <span class="material-icons destaque-icon primary">
      favorites
    </span>
    Em destaque    
  </p-header>

  <app-sumario-paciente-quadro-perfil-questao-destaque 
    #appSumarioPacienteQuadroPerfilQuestaoDestaque
    [exibirTitulo]="false"
    [exibirMsgNenhumRegistro]="true"
    [paciente]="paciente">
  </app-sumario-paciente-quadro-perfil-questao-destaque>
</p-fieldset>
